import { AgGridModule } from 'ag-grid-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ChipsModule } from '../chips/chips.module';
import { FrequencyModule } from '../frequency/frequency.module';

import { AddWatchOrderDialogComponent } from './add-watch-order-dialog/add-watch-order-dialog.component';
import { AddWatchOrderComponent } from './add-watch-order/add-watch-order.component';
import { CustomSelectAllHeaderComponent } from './add-watch-order/custom-select-all-header/custom-select-all-header.component';
import { AdjustExistingHitOverviewComponent } from './adjust-existing-hit-overview/adjust-existing-hit-overview.component';
import { AdjustHitOverviewComponent } from './adjust-hit-overview/adjust-hit-overview.component';
import { AlertActionbarComponent } from './alert-actionbar/alert-actionbar.component';
import { ActionsRendererComponent } from './alert-columns/actions-renderer/actions-renderer.component';
import { BccRendererComponent } from './alert-columns/bcc-renderer/bcc-renderer.component';
import { CcRendererComponent } from './alert-columns/cc-renderer/cc-renderer.component';
import { FrequencyRendererComponent } from './alert-columns/frequency-renderer/frequency-renderer.component';
import { PanelViewRowRendererComponent } from './alert-columns/panel-view-row-renderer/panel-view-row-renderer.component';
import { ProductsRendererComponent } from './alert-columns/products-renderer/products-renderer.component';
import { StatusRendererComponent } from './alert-columns/status-renderer/status-renderer.component';
import { SubjectRendererComponent } from './alert-columns/subject-renderer/subject-renderer.component';
import { TitleRendererComponent } from './alert-columns/title-renderer/title-renderer.component';
import { WatchOrderActionRendererComponent } from './alert-columns/watch-order-action-renderer/watch-order-action-renderer.component';
import { AlertGridComponent } from './alert-grid/alert-grid.component';
import { AlertSettingsComponent } from './alert-settings/alert-settings.component';
import { CreateNewAlertComponent } from './create-new-alert/create-new-alert.component';
import { HitOverviewColumnsComponent } from './hit-overview-columns/hit-overview-columns.component';
import { OrderActionsDialogComponent } from './order-actions-dialog/order-actions-dialog.component';
import { ReferenceChipsComponent } from './reference-chips/reference-chips.component';
import { WatchAlertsOrdersGridComponent } from './watch-alerts-orders-grid/watch-alerts-orders-grid.component';

@NgModule({
  declarations: [
    AlertSettingsComponent,
    AlertActionbarComponent,
    TitleRendererComponent,
    StatusRendererComponent,
    ActionsRendererComponent,
    FrequencyRendererComponent,
    SubjectRendererComponent,
    CcRendererComponent,
    BccRendererComponent,
    AlertGridComponent,
    ProductsRendererComponent,
    CreateNewAlertComponent,
    AddWatchOrderComponent,
    PanelViewRowRendererComponent,
    WatchOrderActionRendererComponent,
    OrderActionsDialogComponent,
    WatchAlertsOrdersGridComponent,
    AdjustHitOverviewComponent,
    CustomSelectAllHeaderComponent,
    ReferenceChipsComponent,
    AddWatchOrderDialogComponent,
    AdjustExistingHitOverviewComponent,
    HitOverviewColumnsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatChipsModule,
    MatRadioModule,
    MatButtonToggleModule,
    AgGridModule,
    MatSlideToggleModule,
    MatDividerModule,
    ChipsModule,
    FrequencyModule,
    MatDialogModule,
    MatStepperModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    DragDropModule,
  ],
})
export class WatchAlertModule {}
